var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-winners",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-winners:not(.animated) .animable {opacity: 0;}svg#freepik_stories-winners.animated #freepik--character-2--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-winners.animated #freepik--Cup--inject-2 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 217.23px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "elyw4b2doc9dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "433.34px 398.615px"
    },
    id: "elmmdc853vyrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "326.875px 401.335px"
    },
    id: "elxah8si6ijql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "406.185px 389.335px"
    },
    id: "elh5j5wmqbau9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "74.055px 391.015px"
    },
    id: "elcuziis14fp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.725px 391.015px"
    },
    id: "el1rugd0fnrz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.31px 395.235px"
    },
    id: "el5hlm4jp5ed6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "elib1pvqavm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "elwgvtudx54pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92,78h12.56s-3.49,12.32-10.23,16c-3.66,2-11.44-4-11.44-4S92.11,86.46,92,78Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "93.725px 86.2041px"
    },
    id: "el8ofnyqz1tbw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.91,85.89s-3.64,6-7.64,6.87a17.48,17.48,0,0,1-2.66,10.17C151.44,102.43,159.72,94.34,154.91,85.89Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "150.477px 94.41px"
    },
    id: "el6sh6xyrmgvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.17,141.67s-4-.11-7.67-4.34c-2.78,1.84-2.33,5.84-2.33,5.84s5.5,3.33,10,4.33A21.27,21.27,0,0,0,63.17,141.67Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.2569px 142.415px"
    },
    id: "els1ssestqnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.79,203.47s-3.94-.11-7.67-4.33c-2.77,1.83-2.33,5.83-2.33,5.83s5.5,3.33,10,4.33A21.27,21.27,0,0,0,448.79,203.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "443.878px 204.22px"
    },
    id: "elmgogcn1j72b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.83,137.33c-2-2.16-5-8.33-5-8.33s-2.83,3.17-2.66,5.17,5.83,4.66,5.83,4.66Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "104.996px 133.915px"
    },
    id: "elxskx8qv53t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.36,49.78c-2.57-2.32-11.64-6.57-11.64-6.57s6.54-2.72,10-2,5.52,7.42,5.52,7.42Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "101.48px 45.4343px"
    },
    id: "el06wusgzkiqku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.72,75.75c2.21,0,8.34-1.72,8.34-1.72s-2,4-3.95,5.17S200.36,78,200.36,78Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "205.21px 76.7773px"
    },
    id: "elcmz8scqgjto",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.38,93,403,88.57s6.66-7,12.45-7c3.14,0,6.21,6.7,6.21,6.7S414.29,87.33,411.38,93Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "412.33px 87.285px"
    },
    id: "elzvl9hhgump",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.2,46.65s6.05-3.64,10-2.51a17.43,17.43,0,0,1,7.11-7.73C348,33.65,336.91,36.93,337.2,46.65Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "345.752px 41.0594px"
    },
    id: "elvgqb1f351rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.71,217.59s1.13-4.55,3.5-5.86a11.57,11.57,0,0,1-.3-7C57.68,206.42,54,213.16,58.71,217.59Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "59.3581px 211.16px"
    },
    id: "elyvwpyt457b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.79,38.17s3.43,1.95,4.75,7.42c3.31-.32,4.79-4.06,4.79-4.06S430,36,426.51,33A21.36,21.36,0,0,0,423.79,38.17Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "428.56px 39.295px"
    },
    id: "el925jfgl6gmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.48,45.61a6.72,6.72,0,0,1-5.08-.19c-.94,1.67.35,3.61.35,3.61A23.85,23.85,0,0,0,265,48.6,12.65,12.65,0,0,0,263.48,45.61Z",
    style: {
      fill: "rgb(230, 230, 230)",
      transformOrigin: "261.529px 47.2487px"
    },
    id: "elwa9bdoj82u9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.27,86.51c.75,2.85.52,9.7.52,9.7s4-1.47,4.77-3.32-3-6.85-3-6.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "447.967px 91.125px"
    },
    id: "eltqudrx6co58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.08,97.33c-2.64,2.16-8.12,10.35-8.12,10.35s-1.68-6.76-.5-10,8-4.26,8-4.26Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "373.56px 100.55px"
    },
    id: "el9mllivjurr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.39,233.75l.78,6.44a21.88,21.88,0,0,1,.28,3.22l-.13,3.22c-.17,4.29-.43,8.58-.83,12.87a.54.54,0,0,1-.59.49.56.56,0,0,1-.49-.49c-.4-4.29-.66-8.58-.83-12.87l-.13-3.22a21.88,21.88,0,0,1,.28-3.22l.78-6.44a.44.44,0,0,1,.49-.39A.45.45,0,0,1,96.39,233.75Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "95.95px 246.675px"
    },
    id: "elwt7fauy183c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.39,272.4l.78,6.44a21.74,21.74,0,0,1,.28,3.21l-.13,3.22c-.17,4.29-.43,8.59-.83,12.88a.54.54,0,0,1-1.08,0c-.4-4.29-.66-8.59-.83-12.88l-.13-3.22a21.74,21.74,0,0,1,.28-3.21l.78-6.44a.44.44,0,0,1,.88,0Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "95.95px 285.325px"
    },
    id: "elg0ptkr5nin5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,266.4l-7.75.77a31.48,31.48,0,0,1-3.87.28L74,267.32q-7.76-.24-15.49-.83a.54.54,0,0,1,0-1.08c5.16-.4,10.32-.66,15.49-.83l3.87-.13a31.48,31.48,0,0,1,3.87.28l7.75.78a.44.44,0,0,1,.4.49A.45.45,0,0,1,89.5,266.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "73.933px 265.95px"
    },
    id: "ellyc5gnctb9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.11,251.42l-2,3.12A7.38,7.38,0,0,1,108,256l-1.37,1.2c-1.84,1.58-3.73,3.12-5.74,4.54a.55.55,0,0,1-.76-.76c1.42-2,3-3.9,4.54-5.74l1.21-1.37a7,7,0,0,1,1.48-1.08l3.12-2a.47.47,0,0,1,.63.14A.46.46,0,0,1,111.11,251.42Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "105.612px 256.275px"
    },
    id: "elnv9cggym0zi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7,270.83l-2.79,3.88a11.77,11.77,0,0,1-1.47,1.87l-1.75,1.59c-2.36,2.09-4.76,4.14-7.28,6.08a.54.54,0,0,1-.76-.1.56.56,0,0,1,0-.66c1.94-2.52,4-4.92,6.08-7.28l1.59-1.75A12.24,12.24,0,0,1,87.19,273l3.89-2.79a.44.44,0,0,1,.62.1A.45.45,0,0,1,91.7,270.83Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "84.6626px 277.244px"
    },
    id: "el7vbyygablk7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.08,261.71l-7.23-6.14a45.89,45.89,0,0,1-3.54-3.14L77.06,249q-6.5-6.85-12.77-13.95a.54.54,0,0,1,0-.75.52.52,0,0,1,.71,0q7.11,6.24,14,12.77l3.43,3.24c1.15,1.08,2.1,2.35,3.14,3.54l6.13,7.23a.45.45,0,0,1,0,.63A.45.45,0,0,1,91.08,261.71Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "77.9836px 247.997px"
    },
    id: "elwyevpdeawdm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.48,109.2,345,110a21.88,21.88,0,0,1-3.22.28l-3.22-.13c-4.29-.17-8.58-.43-12.87-.83a.55.55,0,0,1-.49-.59.56.56,0,0,1,.49-.49c4.29-.4,8.58-.66,12.87-.83l3.22-.13a21.88,21.88,0,0,1,3.22.28l6.44.78a.44.44,0,0,1,0,.88Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "338.539px 108.78px"
    },
    id: "elowdny5703n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.83,109.2l-6.44.78a21.74,21.74,0,0,1-3.21.28l-3.22-.13c-4.29-.17-8.58-.43-12.88-.83a.54.54,0,0,1,0-1.08c4.3-.4,8.59-.66,12.88-.83l3.22-.13a21.74,21.74,0,0,1,3.21.28l6.44.78a.44.44,0,0,1,0,.88Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "299.905px 108.76px"
    },
    id: "els03xpcpiyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.84,102.31l-.78-7.75a31.48,31.48,0,0,1-.28-3.87l.13-3.87c.17-5.16.43-10.33.83-15.49a.55.55,0,0,1,.58-.5.55.55,0,0,1,.5.5c.4,5.16.66,10.33.83,15.49l.13,3.87a31.48,31.48,0,0,1-.28,3.87l-.78,7.75a.43.43,0,0,1-.48.4A.44.44,0,0,1,318.84,102.31Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "319.28px 86.771px"
    },
    id: "elqn1ufiwd4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.81,123.92l-3.12-2a7,7,0,0,1-1.48-1.08L328,119.44c-1.58-1.84-3.12-3.73-4.54-5.74a.55.55,0,0,1,.13-.76.54.54,0,0,1,.63,0c2,1.42,3.9,3,5.74,4.54l1.37,1.21a7,7,0,0,1,1.08,1.48l2,3.12a.47.47,0,0,1-.14.63A.46.46,0,0,1,333.81,123.92Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "328.919px 118.41px"
    },
    id: "el7ov3ykikb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.41,104.51l-3.89-2.79a12.24,12.24,0,0,1-1.87-1.47l-1.59-1.75c-2.09-2.36-4.14-4.76-6.08-7.28a.54.54,0,0,1,.1-.76.56.56,0,0,1,.66,0c2.52,1.94,4.92,4,7.28,6.08l1.75,1.59a12.24,12.24,0,0,1,1.47,1.87l2.79,3.89a.44.44,0,0,1-.62.62Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "308px 97.483px"
    },
    id: "eljcqj8pwyef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.53,103.89l6.13-7.23a45.89,45.89,0,0,1,3.14-3.54l3.43-3.24q6.86-6.51,13.95-12.78a.54.54,0,0,1,.76.76q-6.26,7.11-12.78,14l-3.24,3.43a45.89,45.89,0,0,1-3.54,3.14l-7.23,6.13a.43.43,0,0,1-.62-.05A.43.43,0,0,1,323.53,103.89Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "337.23px 90.8232px"
    },
    id: "elnrh0ac0mtb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "359.307px 258.302px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.27,191.19c-.64.47-1.13.82-1.69,1.19s-1.09.71-1.64,1.07c-1.09.68-2.2,1.35-3.31,2-2.25,1.26-4.54,2.44-6.91,3.49a72.24,72.24,0,0,1-7.26,2.82c-1.23.44-2.51.78-3.78,1.13l-1.93.47-.48.12-.34.07-.41.08a10,10,0,0,1-1.76.17,9.9,9.9,0,0,1-3.58-.59,10.73,10.73,0,0,1-2.9-1.6,15.15,15.15,0,0,1-3.53-4,30.1,30.1,0,0,1-3.28-7.84,61.1,61.1,0,0,1-2.08-15.27,2.87,2.87,0,0,1,5.64-.83l0,.14a96,96,0,0,0,4.5,13.09,24,24,0,0,0,3,5.25,5.1,5.1,0,0,0,1.45,1.31c.39.17.34,0,.33,0a19.71,19.71,0,0,1,2.15-.78c1-.41,2.09-.78,3.12-1.23,2.08-.84,4.13-1.84,6.16-2.85s4-2.12,6-3.28c1-.56,2-1.15,2.93-1.75l2.76-1.77.23-.15a5.77,5.77,0,0,1,6.52,9.52Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "356.003px 187.674px"
    },
    id: "el6wdlo93ow8o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4,178.32l.3-8.32-9.28,2.94A7.34,7.34,0,0,0,334,180.3Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "334.05px 175.15px"
    },
    id: "el5e7ctnjxctr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.46,165.09l-3.4,2.63a2.34,2.34,0,0,0-.9,2.06l.26,3.16L338.7,170l-1.63-3.95A2.35,2.35,0,0,0,333.46,165.09Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "333.925px 168.769px"
    },
    id: "el00b7vgeos9qkh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.05,176.75c-6.49,1.11-13.31,8.13-13.31,8.13s1.66,7.64,3,15.25C382.9,197.92,388.32,174.66,376.05,176.75Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "372.723px 188.374px"
    },
    id: "elluupih65okm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.43,186.12a552.49,552.49,0,0,1,0,59.54l40.69,3c3.57-21.36,2.88-41.61,3.27-61.84.11-5.81-1.61-11.15-7.4-11.7-2.14-.2-7-.26-8.89-.22a146.08,146.08,0,0,0-17.08,1.2c-1.22.21-2.43.45-3.57.72A9,9,0,0,0,368.43,186.12Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "390.405px 211.774px"
    },
    id: "elemdnmcs6s3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr2iix8jgzo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.48,186.76s2.86,9.36,8.73,11.51c0-3.73.06-7.46.13-11.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "407.91px 192.515px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.49,242.83s-29.37,28.32-39.44,49.28c-10.47,21.8-29.39,63.24-29.39,63.24l6.22,3.11s36.08-46.94,38.49-59.7c13.16-22.29,46.38-32.57,52.07-51.71C384.36,243.46,368.49,242.83,368.49,242.83Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "348.05px 300.645px"
    },
    id: "elndv8s7jz57c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.83,245.66s-4.44,40.07-3.1,62.35c1.48,24.41,14,68.56,14,68.56l6-.31s1.81-37.63-5.08-64.55c4-17.85,15.74-44,15.4-63.06A181.58,181.58,0,0,0,381.83,245.66Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "393.768px 311.115px"
    },
    id: "elgano5fq28q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.83,375.94c-1.5-1.41-3.56-3-3.88-6.93,0,0-7.16,3.29-6.66,6s.37,11.39-4.37,16.83c-.66.76,1.32,1.64,3.51.82,3.72-1.39,4.05-2.78,5-5.93.82-2.7,4.89-5.52,6.53-7.06C404.33,378.35,404.33,377.35,402.83,375.94Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "395.881px 380.999px"
    },
    id: "eliuxd9sofu9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,364c.86-1.86.6-4.51,2.79-7.3,0,0-4-4.94-6.05-3.14s-8,3.25-14.84,1c-1-.32-1.54,2.58.58,3.55,3.52,1.61,6.12,2.75,9.12,4.12,2.56,1.17,3,2,4.93,3.11C302.33,366.23,303.28,365.91,304.15,364Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "296.055px 359.489px"
    },
    id: "elyiuhi6c2lyt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.4,176.2c4.9-2,4.47-6.28,3.26-10.26l10.56-9.49c-.81,5.63-1.78,14.91,2.31,18.43,0,0-2.31,7.65-13.47,9.6C380.69,182.81,379.53,177.17,382.4,176.2Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "389.679px 170.465px"
    },
    id: "elp3motaa1m0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsob62ecrsdd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.68,160.25l-6,5.68a16.93,16.93,0,0,1,.69,3c1.61.14,5.92-2.2,6-4.7A13.76,13.76,0,0,0,391.68,160.25Z",
    style: {
      opacity: 0.2,
      transformOrigin: "389.025px 164.593px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422.15,139.18l-4.85-7.57,9.44-2.37s3,7.58,0,9.52Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "422.687px 134.21px"
    },
    id: "elvpqw8qvgdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.42,176.91l.55-.23.68-.31,1.4-.67c.93-.47,1.86-1,2.77-1.52a49.35,49.35,0,0,0,5.23-3.53,40.69,40.69,0,0,0,4.59-4.19c.69-.76,1.34-1.54,2-2.34l.82-1.11a5.93,5.93,0,0,0,.49-.84,6.49,6.49,0,0,0,.33-.87,5,5,0,0,0,.2-1.14c.12-1.08.25-2.16.29-3.24s.08-2.18.1-3.27,0-2.19-.13-3.28a48.52,48.52,0,0,0-.91-6.54c-.23-1.08-.46-2.17-.78-3.22-.14-.53-.32-1.05-.49-1.57l-.49-1.43-.15-.41a2.85,2.85,0,0,1,5-2.62c.49.67.83,1.16,1.2,1.75s.68,1.13,1,1.71c.64,1.15,1.2,2.33,1.73,3.53a44.2,44.2,0,0,1,2.39,7.47,46.66,46.66,0,0,1,1.12,7.81c.09,1.32.09,2.63.08,4a13.37,13.37,0,0,1-.17,2.44,16.09,16.09,0,0,1-.65,2.59,18.53,18.53,0,0,1-1.06,2.41l-.33.58-.27.46-.54.88a36.26,36.26,0,0,1-2.4,3.38,43.38,43.38,0,0,1-5.67,5.9,48,48,0,0,1-6.54,4.75c-1.16.68-2.34,1.33-3.56,1.93-.61.3-1.22.59-1.86.87l-1,.4-1.13.42a5.77,5.77,0,0,1-4.21-10.74Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "416.988px 160.796px"
    },
    id: "elal5at5a52lq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.67,174.88c4.78,0,13.67-3.78,13.67-3.78s5.25,9.68,6,14.76a23.23,23.23,0,0,1-12.8,9.32C400.71,192.12,398.06,184.48,399.67,174.88Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "409.273px 183.14px"
    },
    id: "elaulr4zj8b25",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.1,291.24s-11.66-4.78-18.24-13c7.4-14.16,24.62-34.24,29.69-35.73a40.16,40.16,0,0,1,2.23-4.79l33,4.91C399,258.65,364.43,283.29,354.1,291.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.32px 264.48px"
    },
    id: "el4gh973rn4fx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrgupjqucd7t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.55,258.33c-4.52,2.06-9,13.24-10.35,22.09a214.86,214.86,0,0,0,19.1-16.8C383.65,260.72,379.45,257.93,378.55,258.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "377.75px 269.356px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,294.09s8.56,2.38,23.65-.26c2.76-15.14,13.68-38.75,10.13-45.73a7.71,7.71,0,0,0,.44-5l-40.7-5C367.24,243.16,376.7,279,377.06,294.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "390.705px 266.587px"
    },
    id: "elah3kj8d88g9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,124.64l5.15-1a1.59,1.59,0,0,1,1.77,1l1.78,4.63-9.44,2.37-.52-5.28A1.56,1.56,0,0,1,418,124.64Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "421.714px 127.627px"
    },
    id: "elzaee2iki4ir",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,139.11c-6.48-.69-9.47,3.19-5.33,10.76C385.86,142.59,386,139.11,386,139.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.383px 144.451px"
    },
    id: "el1kd3xoo13ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.91,150.6c-1.88,7.33-2.61,11.71-7.09,14.8-6.73,4.64-15.23-.52-15.57-8.26-.31-7,2.81-17.77,10.64-19.33A10.32,10.32,0,0,1,400.91,150.6Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "389.746px 152.381px"
    },
    id: "el3j4c741cb1x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.29,157.66l-5.47-3s.77-4.55,3.64-6.16c-2.49-1.38-4.15-4.95-4-6.61-3.91,1-9.64.31-12-1.1-4.29-2.59-4.12-7.59-.85-9.49,1.07,3.32,2.78,5.06,6.82,3.16s9.68-2.59,11.81.58,7.36.62,10.25,3.34a4.92,4.92,0,0,1-1.73,8.48C412.75,150.84,408.27,156.8,399.29,157.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.723px 144.48px"
    },
    id: "elgsp7dwx0r7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.61,146.48a5.9,5.9,0,0,1,6.68,4.12C410.66,148.94,407.48,146.57,405.61,146.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.95px 148.495px"
    },
    id: "el15uy9mllp8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,146.39a4.65,4.65,0,0,0,6.09-1.15C410.41,146,407.39,146.86,406,146.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "409.045px 146.149px"
    },
    id: "elnz93t3j9bs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.82,157.21a7.2,7.2,0,0,1-4.62,3c-2.48.43-3.47-1.85-2.57-4.06.81-2,3.08-4.62,5.47-4S404.13,155.28,402.82,157.21Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "399.395px 156.16px"
    },
    id: "elddcbznlekh5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.27,150.51c-.12.6-.53,1-.93,1s-.62-.63-.5-1.23.53-1,.92-1S389.38,149.91,389.27,150.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.552px 150.395px"
    },
    id: "el2t5r8xua91t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.44,149.2c-.11.6-.53,1-.92,1s-.62-.63-.51-1.24.54-1,.93-.95S382.56,148.6,382.44,149.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.727px 149.103px"
    },
    id: "elq5s1tgh55bf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.32,149.87a22,22,0,0,1-3.87,4.61,3.56,3.56,0,0,0,2.78,1.1Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "382.385px 152.728px"
    },
    id: "el56pg0w9cd4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.6,158.08a5.42,5.42,0,0,1-1.36-.1.19.19,0,0,1-.15-.21.18.18,0,0,1,.22-.14,4.83,4.83,0,0,0,4.25-1.12.18.18,0,1,1,.26.25A5,5,0,0,1,385.6,158.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "386.479px 157.271px"
    },
    id: "eltel7p4hp8cr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393,147.71a.38.38,0,0,1-.31-.25,2.9,2.9,0,0,0-1.77-1.92.36.36,0,0,1-.25-.44.35.35,0,0,1,.44-.25,3.56,3.56,0,0,1,2.27,2.39.35.35,0,0,1-.23.45A.39.39,0,0,1,393,147.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.029px 146.273px"
    },
    id: "eluq4rdcipa9q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.22,144.7a.36.36,0,0,1-.21-.13.36.36,0,0,1,.06-.51,3.53,3.53,0,0,1,3.21-.72.35.35,0,0,1,.23.45.36.36,0,0,1-.45.23,2.87,2.87,0,0,0-2.54.6A.38.38,0,0,1,380.22,144.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.73px 143.961px"
    },
    id: "elxdrqfwcrwrs",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cup--inject-2",
    className: "animable",
    style: {
      transformOrigin: "238.5px 264.805px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "247.25 342.02 229.76 342.02 227.01 282.89 250 282.89 247.25 342.02",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "238.505px 312.455px"
    },
    id: "elne42gcdqxgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbagn5q1gd7o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.11,302h0a17.17,17.17,0,0,1-21.21,0h0L227,282.9h23Z",
    style: {
      opacity: 0.2,
      transformOrigin: "238.5px 294.283px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M187,252.93c-24.27,0-47.35-18.16-53.7-42.24L122,167.76a24.52,24.52,0,0,1,3.9-21.45,23.56,23.56,0,0,1,18.93-9H179.4a8.32,8.32,0,0,1,0,16.63H144.84a6.92,6.92,0,0,0-5.76,2.5,8,8,0,0,0-1,7.06l11.32,42.94c4.41,16.73,20.94,29.84,37.62,29.84a8.32,8.32,0,1,1,0,16.63Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "158.334px 195.118px"
    },
    id: "eln2xsgy7qt9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,252.93a8.32,8.32,0,1,1,0-16.63c16.68,0,33.21-13.11,37.62-29.84l11.31-42.94a8,8,0,0,0-1-7.06,6.92,6.92,0,0,0-5.76-2.5H297.61a8.32,8.32,0,1,1,0-16.63h34.56a23.57,23.57,0,0,1,18.93,9,24.52,24.52,0,0,1,3.9,21.45l-11.31,42.93C337.34,234.77,314.25,252.93,290,252.93Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "318.676px 195.13px"
    },
    id: "elqobx78jwhf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw48vilsev6"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "238.5px 195.13px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.71,145.65a8.32,8.32,0,0,0-8.31-8.32H150.47l2,16.63H179.4A8.31,8.31,0,0,0,187.71,145.65Z",
    id: "el8bflkffo6pt",
    className: "animable",
    style: {
      transformOrigin: "169.09px 145.645px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,236.3c-9.41,0-18.76-4.16-25.93-10.8l1.17,9.69a74.27,74.27,0,0,0,2.67,12.72,52.53,52.53,0,0,0,22.09,5,8.32,8.32,0,1,0,0-16.63Z",
    id: "eluv07e3uzqx",
    className: "animable",
    style: {
      transformOrigin: "178.339px 239.208px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.67,244.62a8.32,8.32,0,0,0,8.31,8.31,52.54,52.54,0,0,0,22.1-5,74.27,74.27,0,0,0,2.67-12.72l1.16-9.69c-7.16,6.64-16.51,10.8-25.93,10.8A8.32,8.32,0,0,0,281.67,244.62Z",
    id: "elquzbxsjkpb8",
    className: "animable",
    style: {
      transformOrigin: "298.79px 239.225px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.61,137.33a8.32,8.32,0,0,0,0,16.63h26.92l2-16.63Z",
    id: "ell6lxptth74",
    className: "animable",
    style: {
      transformOrigin: "308.054px 145.645px"
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 224.08,
    y: 115.87,
    width: 7.08,
    height: 1,
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "227.62px 116.37px"
    },
    id: "elhaoxo70ndz7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.5,
    y: 115.87,
    width: 25.42,
    height: 1,
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "205.21px 116.37px"
    },
    id: "eluhdqwz3twlr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.5,294.19h0a69.31,69.31,0,0,1-69.08-63.66l-8.69-106.34a4.45,4.45,0,0,1,4.44-4.82H311.84a4.46,4.46,0,0,1,4.44,4.82l-8.69,106.34A69.32,69.32,0,0,1,238.5,294.19Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "238.505px 206.78px"
    },
    id: "elxgkntk1pd1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpbak5wxbglq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.11,275a1.74,1.74,0,0,1-1.9,2.85,58.26,58.26,0,0,1-33.74-48.19l-7.88-96.3a2.65,2.65,0,0,1,2.63-2.86h11.95a2.63,2.63,0,0,1,2.63,2.44l7.67,101a64.44,64.44,0,0,0,18.57,41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "194.613px 204.247px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.12,363.1H202.89a3.06,3.06,0,0,1-3-3.62l2.23-11.85a12.33,12.33,0,0,1,12.11-10.05h48.55a12.33,12.33,0,0,1,12.11,10.05l2.23,11.85A3.06,3.06,0,0,1,274.12,363.1Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "238.505px 350.34px"
    },
    id: "els8hlqslxzlh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elc07blh06avl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.12,359.48H199.89a3.06,3.06,0,0,0,3,3.62h71.23A3.06,3.06,0,0,0,277.12,359.48Z",
    style: {
      opacity: 0.2,
      transformOrigin: "238.505px 361.29px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 177.86,
    y: 363.1,
    width: 121.28,
    height: 50.64,
    rx: 3.04,
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "238.5px 388.42px"
    },
    id: "elfh46xyhhrd4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellie7oktt8dj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 177.86,
    y: 363.1,
    width: 121.28,
    height: 50.64,
    rx: 3.04,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "238.5px 388.42px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "171.587px 312.42px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.87,222.51c-2.7-14,19.91-18.22,30.09-9.29,9.94,8.72,4.76,16.38,18.9,14.08s15.58,11.25,8.18,16.19,4.42,15.12-8.09,19.5c-15.48,5.43-30,.51-40.44-4.64S127.46,228.84,139.87,222.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.852px 236.944px"
    },
    id: "eloncr52sp9wb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.06,307.62S233.47,334.2,230.94,351c-6.18,37.86-6.35,57.91-6.35,57.91h-6.78s-6.43-37.88-3-57.22c-4.22-8.67-56.2-6.87-52.68-44.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.497px 358.245px"
    },
    id: "eliksmqjrvze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9hubrgf9su"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.31,315.64c2,14.16,13.67,21.19,25.51,25.6C179.07,331.33,169.1,320.72,162.31,315.64Z",
    style: {
      opacity: 0.2,
      transformOrigin: "175.065px 328.44px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.17,407.65h-7.92a.66.66,0,0,0-.68.59l-.8,6.5a1.5,1.5,0,0,0,1.51,1.54c3.48-.06,5.16-.25,9.56-.25,2.7,0,4.35.28,8.09.28s3.75-3.58,2.17-3.91c-7-1.47-8-2.28-10.42-4.2A2.45,2.45,0,0,0,225.17,407.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "226.933px 411.98px"
    },
    id: "el2crk2lkhxo5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.26,255.79c2.16.67,4.44,1.39,6.67,2s4.49,1.32,6.73,1.88,4.49,1.1,6.7,1.52c1.09.19,2.2.4,3.26.52l.8.11.77.06.76.06h.13v0s-.1.07-.06.08.15-.06.31-.28a6.94,6.94,0,0,0,.9-2.15,30.58,30.58,0,0,0,.84-6.34c.12-2.26.1-4.58,0-6.9s-.24-4.71-.42-7v-.08a2.2,2.2,0,0,1,4.3-.78,73.84,73.84,0,0,1,2.72,14.65,33.69,33.69,0,0,1-.24,8,14.59,14.59,0,0,1-1.53,4.58,8.49,8.49,0,0,1-2,2.43,7.6,7.6,0,0,1-3.29,1.59c-.29.06-.6.11-.88.14l-.43,0h-2.4l-1-.05c-1.33-.06-2.59-.22-3.87-.38-2.52-.33-5-.79-7.39-1.34a124.89,124.89,0,0,1-14.23-4,4.42,4.42,0,0,1,2.75-8.39Z",
    style: {
      fill: "rgb(128, 62, 60)",
      transformOrigin: "194.688px 253.406px"
    },
    id: "elwksa8gt36dl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.34,233.1l-5.82,4s.42.71,1.5,2.44,2.88,2.79,4.51,1.7C214.58,239.21,210.34,233.1,210.34,233.1Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "208.401px 237.391px"
    },
    id: "el8b9e745d9kg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.63,233.66l1.27-1.53a2.34,2.34,0,0,1,3.61,0l.83,1-5.82,4-.34-1.3A2.34,2.34,0,0,1,204.63,233.66Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "207.212px 234.205px"
    },
    id: "elebwyo8oao2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.07,265.33c.4,7.29-.24,19.79-2,42.29h-35.4c.56-13.49-.27-18.51-8.23-43.52a4.62,4.62,0,0,1,3.29-5.88,97.18,97.18,0,0,1,9.9-2,111.38,111.38,0,0,1,15.87-1.4c2.08,0,4.25.09,6.26.21A10.93,10.93,0,0,1,187.07,265.33Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "164.204px 281.22px"
    },
    id: "elf5nwnjy2tg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4mjohdcyt1r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.45,265.3a27.64,27.64,0,0,1-.46,10.64c-.67-2.39-1.42-4.95-2.27-7.75Z",
    style: {
      opacity: 0.2,
      transformOrigin: "144.242px 270.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elugsuqojhnrc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.39,272.54c0-3.36-4.36-7.56-7.41-8.25C164.18,265.53,168.28,269.93,169.39,272.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "165.685px 268.415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.61,238.25c1.45,5,3.28,14.28,0,18,0,0,1.86,5.06,11.35,4.22,10.43-.93,4.52-5.62,4.52-5.62-5.81-.86-6-5.09-5.4-9.15Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "163.379px 249.407px"
    },
    id: "elqizweewil9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ela8bc0eip0t4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.88,241.29l6.2,4.41a16.38,16.38,0,0,0-.23,2.86c-2.21-.13-5.41-2.25-5.84-4.51A7.52,7.52,0,0,1,158.88,241.29Z",
    style: {
      opacity: 0.2,
      transformOrigin: "161.944px 244.925px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.5,232.7c4.13,7.51,5.72,10.78,11.5,12.91,8.7,3.19,17-3.52,15.23-12.12-1.63-7.74-8.11-18.73-17.14-18.23A11.7,11.7,0,0,0,146.5,232.7Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "159.228px 230.831px"
    },
    id: "el2k3ezx03z8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.57,221.94c3.5-4.78,9,5.4,9.65,8.61s-.84,7.73-5.84,7.37S139.82,227.07,143.57,221.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.572px 229.312px"
    },
    id: "els8p7gc0w85",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.86,220.69c7.42,3.64,11.73,1.52,14.73-.36s13.67-.83,11.25-3.25-6.15-4.58-12.25-3.63S142.86,220.69,142.86,220.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "156.027px 217.949px"
    },
    id: "el6l38jv7gx7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.92,406.83l-8.11-2.23a.62.62,0,0,0-.73.34l-2.9,6.25a1.18,1.18,0,0,0,.77,1.62c2.84.73,4-.15,7.15,1.8,2.37,1.46,5.54,1.62,9.2,1.62,3.08,0,3.43-3.21,2.09-3.46-6-1.12-5.36-3.11-6.4-5.16A1.67,1.67,0,0,0,116.92,406.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "115.105px 410.404px"
    },
    id: "el4341u1ri7ky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.35,307.62s-5.11,31.36-10,56.88c-.74,3.86-2.49,7.77-5.85,9.82-17.44,10.65-43.25,33.32-43.25,33.32l-7.5-2.38s24.34-37.54,37-39.24c0-10.52-10-37.31,3.92-58.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.05px 357.63px"
    },
    id: "els8xg2izftu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.2,306.28a1.57,1.57,0,0,0-.71,2.05c.37.55,21.62,1.14,27.15,1.1s11.56-.31,11.21-1.3-.13-2.68-.87-2.72S151.41,305.64,149.2,306.28Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "167.606px 307.419px"
    },
    id: "elkgchsjrqshb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,229.67c.3.63.88,1,1.29.79s.5-.86.21-1.49-.88-1-1.29-.79S158.53,229,158.82,229.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "159.57px 229.32px"
    },
    id: "elgzqlf6zi08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,226.31c.29.63.87,1,1.28.79s.51-.87.21-1.5-.87-1-1.29-.78S165.65,225.68,166,226.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "166.731px 225.958px"
    },
    id: "elaerjj68dc6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,224.94l1.31-1.15S167.08,225.33,166,224.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "166.655px 224.397px"
    },
    id: "elxg2q07gzvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.62,228.05a18.91,18.91,0,0,0,4.14,3,3,3,0,0,1-2,1.48Z",
    style: {
      fill: "rgb(99, 15, 15)",
      transformOrigin: "166.69px 230.29px"
    },
    id: "el0g1rzldlopm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,236.26a7.13,7.13,0,0,0,1-.36.21.21,0,0,0,.1-.28.2.2,0,0,0-.27-.09,5.53,5.53,0,0,1-5,0,.21.21,0,0,0-.28.06.22.22,0,0,0,.06.29A5.77,5.77,0,0,0,165.1,236.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.42px 236.014px"
    },
    id: "elk369rc58o9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.28,240a6.26,6.26,0,0,0,4.45,1.77c2.19-.05,2.66-2.17,1.51-3.91-1-1.56-3.4-3.43-5.35-2.54A2.82,2.82,0,0,0,147.28,240Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "150.072px 238.43px"
    },
    id: "elpr5zielb9s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.27,228.82a.41.41,0,0,0,.29-.38c.05-1.89,2.07-3.26,2.09-3.27a.41.41,0,0,0,.11-.57.39.39,0,0,0-.56-.11c-.1.06-2.4,1.62-2.46,3.93a.41.41,0,0,0,.4.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "157.285px 226.628px"
    },
    id: "el9u94ioz1v1v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,221.26a.43.43,0,0,0,.28-.29.41.41,0,0,0-.3-.5,4,4,0,0,0-3.65.76.41.41,0,0,0,0,.58.4.4,0,0,0,.58,0h0a3.27,3.27,0,0,1,2.9-.57A.41.41,0,0,0,167.52,221.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "165.771px 221.125px"
    },
    id: "el7f1mpao77q9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,266.38c-3.11,3.42-6.25,7.09-9.12,10.76-1.44,1.84-2.8,3.73-4,5.62a32,32,0,0,0-3.06,5.61,7.9,7.9,0,0,0-.6,2.22l0,.27a.78.78,0,0,1,0,.09l.08.32.16.64.24.74a64.39,64.39,0,0,0,2.64,6.29c2,4.28,4.27,8.59,6.44,12.89l0,0a2.2,2.2,0,0,1-3.64,2.42,111.59,111.59,0,0,1-8.91-12,53.34,53.34,0,0,1-3.79-6.83l-.42-1c-.13-.35-.25-.73-.38-1.1l-.18-.55c-.06-.23-.13-.55-.18-.81a12.3,12.3,0,0,1-.13-1.55,15.67,15.67,0,0,1,.87-4.9,39.38,39.38,0,0,1,3.56-7.4c1.35-2.24,2.81-4.33,4.31-6.37s3.05-4,4.68-5.93,3.25-3.76,5.06-5.63a4.41,4.41,0,0,1,6.43,6.05Z",
    style: {
      fill: "rgb(128, 62, 60)",
      transformOrigin: "136.505px 286.91px"
    },
    id: "el14qb15iu1po",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,228.3l1.3-1.15S160,228.7,158.87,228.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "159.52px 227.758px"
    },
    id: "eleamwj09dh75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.27,310.74l8.66,3.5-7.77,4.11s-4.64-3.05-4.32-6.63Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "142.877px 314.545px"
    },
    id: "eld4e0xytp3od",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,321.34l-3.75,1.73a1.77,1.77,0,0,1-2.06-.43l-3.83-4.29,7.77-4.11,2.66,4.62A1.76,1.76,0,0,1,150.8,321.34Z",
    style: {
      fill: "rgb(127, 62, 59)",
      transformOrigin: "146.493px 318.736px"
    },
    id: "el6wabqhfajqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.06,260.57c-1.41-4-2.57-5.22-2.57-5.22a10.2,10.2,0,0,0-3.55-.61c1.54,4.46,5.68,15.14-9.31,16.32s-20.38-13.92-20.38-13.92c-2.68,0-3.68.95-3.68.95,4.59,11,9.25,22,3,25.53,1.06,5.27,1.23,12,.91,18.85,6.07-1.22,30.33-4.55,40.39-3.26-.1-6.77-.41-12.54-.86-17.44C190.77,277.07,185.3,265,183.06,260.57Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "165.932px 278.605px"
    },
    id: "elej68y2faapd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcb7euj4fvz"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.06,260.57c-1.41-4-2.57-5.22-2.57-5.22a10.2,10.2,0,0,0-3.55-.61c1.54,4.46,5.68,15.14-9.31,16.32s-20.38-13.92-20.38-13.92c-2.68,0-3.68.95-3.68.95,4.59,11,9.25,22,3,25.53,1.06,5.27,1.23,12,.91,18.85,6.07-1.22,30.33-4.55,40.39-3.26-.1-6.77-.41-12.54-.86-17.44C190.77,277.07,185.3,265,183.06,260.57Z",
    style: {
      fill: "rgb(250, 250, 250)",
      opacity: 0.8,
      transformOrigin: "165.932px 278.605px"
    },
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.fee57c0a77c33fd93d7eb7df1cea1829.svg";
export { ForwardRef as ReactComponent };